import React from 'react'
import SVG from '../SVG/SVG'
import { createUseStyles } from 'react-jss'
import _ from 'lodash'

const capitalizeFirstLetter = string => {
  return string.charAt(0).toUpperCase() + string.slice(1)
}

const useStyles = createUseStyles(theme => ({
  locationTop: {},
  locationHeader: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
    margin: 0,
    padding: 0,
    '@media (max-width: 1024px)': {
      flexDirection: 'column-reverse',
    },
  },
  locationTitleCon: {
    display: 'block',
    color: '#000',
    width: '100%',
    margin: 0,
    padding: 0,

    '& h2': {
      margin: '24px 0 20px 0',
      color: theme.colors.main,
      fontFamily: theme.fontFamily,
      fontWeight: 'bold',
      fontSize: 38,
      lineHeight: '41px',
      textAlign: 'left',
      '@media (max-width: 1024px)': {
        fontSize: 24,
        lineHeight: '29px',
      },
    },
  },
  locationDetailsCon: {
    display: 'block',
    color: theme.colors.black,
    width: '100%',
    padding: '10px 0',
    '& img': {
      borderRadius: 30,
      maxWidth: '100%',
    },
    '@media (max-width: 1024px)': {
      padding: '0 0 10px 0',
      '& img': {
        borderRadius: 0,
        maxWidth: '100%',
      },
    },
  },
  wrapper: {
    maxWidth: 1220,
    margin: '0 auto',
    boxSizing: 'border-box',
    '@media (max-width: 1200px)': {
      padding: '0 15px',
    },
  },
  wrapper2: {
    maxWidth: 1220,
    margin: '0 auto',
    boxSizing: 'border-box',
    textAlign: 'center',
    '@media (max-width: 1200px)': {
      padding: '0',
    },
  },
  wrapper3: {
    maxWidth: 1220,
    margin: '0 auto',
  },
  locationAddressCon: {
    display: 'flex',
    flexDirection: 'row',
    '@media (max-width: 900px)': {
      flexDirection: 'column',
    },
  },
  locationAddress: {
    display: 'flex',
    flexDirection: 'row',
  },
  locationAddressText: {
    margin: '0 0 20px 0',

    '& p': {
      margin: '7px 0 0',
      padding: 0,
      fontSize: 16,
      lineHeight: '22px',
      fontWeight: 300,
      '& a': {
        color: theme.colors.main,
        textDecoration: 'underline',
        '&:hover': {
          color: theme.colors.main,
          fontWeight: 'bold',
        },
      },
    },

    '@media (max-width: 900px)': {
      margin: '0 0 10px 0',
    },
  },
  locationAddressMarker: {
    margin: '10px 10px 0 0',
  },
  locationContact: {
    display: 'flex',
    flexDirection: 'row',
    padding: '10px 0',
    justifyContent: 'space-between',

    '@media (max-width: 900px)': {
      flexDirection: 'column',
      padding: 0,
    },
  },
  locationHours: {
    display: 'flex',
    padding: '10px 0',

    '@media (max-width: 900px)': {
      padding: 0,
    },
  },
  detailsItem: {
    display: 'flex',
    flexDirection: 'row',
    fontWeight: 500,
    padding: 0,

    '@media (max-width: 900px)': {
      padding: '10px 0',
    },

    '& span': {
      fontWeight: 900,
      color: theme.colors.blue,
      marginRight: 20,
    },

    '& a': {
      color: theme.colors.black,
      textDecoration: 'none',
    },
    '& a:hover': {
      color: theme.colors.blue,
      textDecoration: 'underline',
    },
  },
  hoursSection: {
    '& span:first-child': {
      fontSize: 15,
      lineHeight: '18px',
      fontWeight: 500,
      display: 'inline-block',
      marginRight: 5,
    },
    '& span:nth-child(2)': {
      fontSize: 15,
      lineHeight: '18px',
      fontWeight: 300,
    },
  },
}))

export const LocationHeader = props => {
  const classes = useStyles()
  const [mapready, setmapready] = React.useState(false)

  const { location } = props
  // const searchTerm = `Thrifty+car+rental,+${location.map_address}`
  const searchTerm = location.map_address

  React.useEffect(() => {
    setmapready(true)
  }, [])

  return (
    <div className={classes.wrapper3}>
      {!_.isEmpty(location) ? (
        <div className={classes.locationHeader}>
          <div className={classes.locationTitleCon}>
            <div className={classes.wrapper}>
              <h2>{location.label}</h2>

              <div className={classes.locationAddress}>
                <div className={classes.locationAddressMarker}>
                  <img src="/themes/thrifty/assets/images/mark.png" alt="mark" />
                </div>
                <div className={classes.locationAddressText}>
                  <p>
                    <a
                      target="_blank"
                      href={`https://www.google.com/maps/?q=${searchTerm}`}
                      rel="noreferrer"
                    >
                      {location.map_address}
                    </a>
                  </p>
                </div>
              </div>

              {location.toll_free && (
                <div className={classes.locationAddress}>
                  <div className={classes.locationAddressMarker}>
                    <SVG name="Phone" width={16} height={16} />
                  </div>
                  <div className={classes.locationAddressText}>
                    <p>
                      <a href={`tel:${location.toll_free}`}>{location.toll_free}</a>
                    </p>
                  </div>
                </div>
              )}

              {location.email && (
                <div className={classes.locationAddress}>
                  <div className={classes.locationAddressMarker}>
                    <SVG name="Email" width={16} height={16} />
                  </div>
                  <div className={classes.locationAddressText}>
                    <p>
                      <a href={`mailto:${location.email}`}>{location.email}</a>
                    </p>
                  </div>
                </div>
              )}

              <div className={classes.locationAddress}>
                <div className={classes.locationAddressMarker}>
                  <SVG name="Clock" width={16} height={16} />
                </div>
                <div className={classes.locationAddressText}>
                  {location.hours &&
                    location.hours.length > 0 &&
                    location.hours.map((hour, index) => {
                      const { day, opening_time, closing_time } = hour
                      if (opening_time === '00:00' && closing_time === '0:00') return null
                      return (
                        <p
                          className={classes.hoursSection}
                          key={`location-index-hours-${index}-${day}`}
                        >
                          <span>{capitalizeFirstLetter(day)}:</span>
                          <span>
                            {opening_time}-{closing_time}
                          </span>
                        </p>
                      )
                    })}
                </div>
              </div>

              <div>
                <p style={{ fontSize: 16, lineHeight: '22px', fontWeight: 'normal' }}>
                  Where is the branch located?
                </p>
                <p
                  style={{ fontSize: 16, lineHeight: '22px', fontWeight: 300, maxWidth: 570 }}
                  dangerouslySetInnerHTML={{ __html: props.branchlocation }}
                />
              </div>
            </div>
          </div>
          <div className={classes.locationDetailsCon}>
            <div className={classes.wrapper2}>
              {!props.img.endsWith('media') && <img src={props.img} alt={location.label} />}

              {mapready ? (
                location.place_id ? (
                  <iframe
                    width="600"
                    height="450"
                    style={{ maxWidth: '100%', border: 0 }}
                    loading="lazy"
                    allowFullScreen
                    referrerpolicy="no-referrer-when-downgrade"
                    src={`https://www.google.com/maps/embed/v1/place?key=AIzaSyBaoBjA9GKJ21xmg28FYipyqp8NgWlBnrg&q=place_id:${location.place_id}`}
                  ></iframe>
                ) : (
                  <iframe
                    width="600"
                    height="450"
                    style={{ maxWidth: '100%', border: 0 }}
                    loading="lazy"
                    allowFullScreen
                    referrerpolicy="no-referrer-when-downgrade"
                    src={`https://www.google.com/maps/embed/v1/place?key=AIzaSyBaoBjA9GKJ21xmg28FYipyqp8NgWlBnrg&q=${searchTerm}`}
                  ></iframe>
                )
              ) : null}
            </div>
          </div>
        </div>
      ) : null}
    </div>
  )
}

export default LocationHeader
